import __request__ from "routing/request";
export function systemStats(requestOptions) {
  return __request__("GET", "/system/cluster/stats", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function elasticsearchStats(requestOptions) {
  return __request__("GET", "/system/cluster/stats/elasticsearch", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function mongoStats(requestOptions) {
  return __request__("GET", "/system/cluster/stats/mongo", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
